const getFullName = ({ firstName, lastName }) => {
  if (!firstName || !lastName) {
    return ''
  }

  return `${firstName} ${lastName}`
}

const initialData = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
}

const ContactInformation = (props) => {
  const { data = initialData } = props
  const { email, phoneNumber, firstName, lastName } = data

  return (
    <div className="contact-information">
      <span>{getFullName({ firstName, lastName })}</span>
      <span>{email}</span>
      <span>{phoneNumber}</span>
    </div>
  )
}

export default ContactInformation
